import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useQuery } from '@/utils/hooks/useQuery'
import { accessorSectionMap } from '../../playbook.helpers'
import { checklistToCategoryFormat, UNCATEGORIZED_ID } from './checklist.helpers'
import { ChecklistEntryPreview } from './ChecklistEntryPreview'

export const ChecklistNestedPreview = ({ entryId, values, isCreate }) => {
  const { section } = useParams()
  const query = useQuery()
  const { playbook } = useSelector((state) => state.playbook)
  const accessor = accessorSectionMap[section]
  const checklist = playbook.body[accessor]
  const categoryId = query.get('category_id') || null

  const categories = useMemo(() => checklistToCategoryFormat(checklist), [checklist])

  return (
    <>
      {categories.order.map((catId) => {
        const category = categories.entries[catId]
        const isUncategorized = catId === UNCATEGORIZED_ID

        return (
          <div key={catId}>
            {!isUncategorized && (
              <div className="checklist-preview-category-header">{category.name}</div>
            )}
            <div className="checklist-entries">
              {category.order.map((itemId) => {
                const isEditEntry = entryId === itemId
                const entryToUse = isEditEntry ? values : category.entries[itemId]

                return (
                  <ChecklistEntryPreview
                    key={itemId}
                    isEditEntry={isEditEntry}
                    entry={entryToUse}
                  />
                )
              })}
              {isCreate && catId === (categoryId || UNCATEGORIZED_ID) && (
                <ChecklistEntryPreview isEditEntry entry={values} />
              )}
            </div>
          </div>
        )
      })}
    </>
  )
}
